import { ApolloClient, HttpLink, InMemoryCache, split } from '@apollo/client';
import { Socket as PhoenixSocket } from 'phoenix';
import * as AbsintheSocket from '@absinthe/socket';

import { possibleTypes } from '../../../possibleTypes.json';
import { createAbsintheSocketLink } from '@absinthe/socket-apollo-link';
import { getMainDefinition } from '@apollo/client/utilities';
import { getHTTPUrl, getWsUrl, IS_DEV } from './urlResolver';

const phoenixSocket = new PhoenixSocket(getWsUrl());
const absintheSocket = AbsintheSocket.create(phoenixSocket);
const wsLink = createAbsintheSocketLink(absintheSocket);

const httpLinkHeaders = {
  authorization: IS_DEV
    ? `Basic ${process.env['NX_GRAPHQL_API_AUTHORIZATION']}`
    : '',
};

const httpLink = new HttpLink({
  uri: getHTTPUrl(),
  headers: httpLinkHeaders,
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);

    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink as any,
  httpLink
);

const apolloClient = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache({
    possibleTypes,
  }),
});

export default apolloClient;
